import { environment } from '../../../environments/environment';

export const PUBLIC_SESSION_ANT_AI_LIMIT = environment.production ? 150 : 150;
export const PUBLIC_SESSION_ANTI_AI_PHOTOS_PER_SESSION_FOR_PRODUCTION = 250;
export const PUBLIC_SESSION_ANTI_AI_PHOTOS_PER_SESSION_FOR_DEVELOPMENT = 150;
export const PUBLIC_SESSION_ANTI_AI_PHOTOS_PER_SESSION = environment.production
  ? PUBLIC_SESSION_ANTI_AI_PHOTOS_PER_SESSION_FOR_PRODUCTION
  : PUBLIC_SESSION_ANTI_AI_PHOTOS_PER_SESSION_FOR_DEVELOPMENT;
